import { presetProgressions } from "../data/presetProgressions";

export const escalaCromatica = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const escalaCromaticaBemol = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
export const escalaMenor = { menor: [2, 1, 2, 2, 1, 2, 2] };
export const escalaMaior = { maior: [2, 2, 1, 2, 2, 2, 1] };
export const sustenidoeBemol = { "C#": "Db", "D#": "Eb", "F#": "Gb", "G#": "Ab", "A#": "Bb" };

const qualidadePorGrau = {
  1: "maj7",
  2: "m7",
  3: "m7",
  4: "maj7",
  5: "7",
  6: "m7",
  7: "m7(b5)",
};

const semitonsByInterval = {
  1: 0,
  2: 2,
  3: 4,
  4: 5,
  5: 7,
  6: 9,
  7: 11,
  9: 14,
  11: 17,
  13: 21,
};

export function converteSustenidoEmBemol(nota) {
  if (Object.keys(sustenidoeBemol).includes(nota)) {
    return sustenidoeBemol[nota];
  }

  return nota;
}

export function geraUmaEscala(notaInicial, intervalos) {
  const tipoEscala = Object.keys(intervalos)[0];
  const formulaIntervalar = intervalos[tipoEscala];

  notaInicial = converteSustenidoEmBemol(notaInicial);

  const escala = [notaInicial];
  let nota = "";
  const umCaractere = 1;
  let posicaoNotaEscalaCromatica = escalaCromaticaBemol.indexOf(notaInicial);

  for (const passos of formulaIntervalar) {
    posicaoNotaEscalaCromatica = (posicaoNotaEscalaCromatica + passos) % 12;

    if (notaInicial.length === umCaractere) {
      nota = escalaCromatica[posicaoNotaEscalaCromatica];
    } else {
      nota = escalaCromaticaBemol[posicaoNotaEscalaCromatica];
    }

    if (notaInicial === "F") {
      nota = escalaCromaticaBemol[posicaoNotaEscalaCromatica];
    }

    escala.push(nota);
  }

  return escala.concat(escala.slice(1, -1));
}

export function geraEscalaTodosTons(intervalosEscala) {
  const escalas = {};
  let tipo = "";

  if (Object.keys(intervalosEscala)[0] === "menor") {
    tipo = " menor";
  }

  for (let i = 0; i <= 11; i++) {
    const nomeDaEscala = converteSustenidoEmBemol(escalaCromatica[i]);
    escalas[nomeDaEscala + tipo] = geraUmaEscala(escalaCromatica[i], intervalosEscala);
  }

  return escalas;
}

export function geraCampoHarmonico(notaDoTom) {
  const todasEscalas = geraEscalaTodosTons(escalaMaior);
  const escala = todasEscalas[notaDoTom];
  const campoHarmonico = [];

  for (let i = 0; i < 7; i++) {
    const acordes = [];
    let index = i;
    const tamanhoSequencia = escala.length;

    for (let j = 1; j < tamanhoSequencia; j += 2) {
      acordes.push(escala[index]);
      index = (index + 2) % escala.length;
    }

    campoHarmonico.push(acordes);
  }

  return campoHarmonico;
}

export function geraCampoHarmonicoNumerado(notaDoTom) {
  const sequenciaOriginal = geraEscalaTodosTons[notaDoTom];
  const sequenciasPulando = [];

  for (let i = 0; i < 7; i++) {
    const sequenciaPulando = {};
    let index = i;
    const tamanhoSequencia = sequenciaOriginal.length;

    for (let j = 1; j < tamanhoSequencia; j += 2) {
      sequenciaPulando[j] = sequenciaOriginal[index];
      index = (index + 2) % sequenciaOriginal.length;
    }

    sequenciasPulando.push(sequenciaPulando);
  }

  return sequenciasPulando;
}

export function geraTodosCamposHarmonicos() {
  const camposHarmonicosNumerados = {};
  const todasEscalas = geraEscalaTodosTons(escalaMaior);

  for (const escala in todasEscalas) {
    const campoHarmonico = geraCampoHarmonico(escala);

    const campoNumerado = campoHarmonico.reduce((acc, sequencia, index) => {
      const notasNumeradas = {};
      for (let i = 0; i < sequencia.length; i++) {
        const indice = i * 2 + 1;
        notasNumeradas[indice] = sequencia[i];
      }
      acc[index + 1] = notasNumeradas;
      return acc;
    }, {});

    camposHarmonicosNumerados[escala] = campoNumerado;
  }

  return camposHarmonicosNumerados;
}

export function exibeCampoHarmonicoNaTela() {
  const todosCamposHarmonicos = geraTodosCamposHarmonicos();
  const ulPrincipal = document.getElementById("box");

  for (const tom in todosCamposHarmonicos) {
    if (todosCamposHarmonicos.hasOwnProperty(tom)) {
      const listItem = document.createElement("li");
      listItem.textContent = tom;

      const notesList = document.createElement("ul");
      const campoHarmonico = todosCamposHarmonicos[tom];

      for (const grau in campoHarmonico) {
        if (campoHarmonico.hasOwnProperty(grau)) {
          const acordes = Object.values(campoHarmonico[grau]);
          const noteListItem = document.createElement("li");
          noteListItem.textContent = `${grau}: ${acordes.join(", ")}`;
          notesList.appendChild(noteListItem);
        }
      }

      listItem.appendChild(notesList);
      ulPrincipal.appendChild(listItem);
    }
  }
}

export function obterAcorde(escala, tone_hand_left, tone_hand_right) {
  const handLeft = tone_hand_left.split(",").map(Number);
  const handRight = tone_hand_right.split(",").map(Number);

  const left = handLeft.map((el) => `${escala[el]}`);
  const right = handRight.map((el) => `${escala[el]}`);

  return `${left}  | ${right}`;
}

function parseIntervalos(side) {
  return side.split(",").map((v) => v.trim());
}

function nomeAcorde(grau, notasMap) {
  const root = (notasMap && (notasMap[1] || Object.values(notasMap)[0])) || "";
  const quality = qualidadePorGrau[grau] || "";
  return `${root}${quality}`;
}

function getChromaticScale(preference) {
  return preference === "sharp" ? escalaCromatica : escalaCromaticaBemol;
}

function transposeNote(root, semitones, preference) {
  const rootBemol = converteSustenidoEmBemol(root);
  const rootIndex = escalaCromaticaBemol.indexOf(rootBemol);
  const noteIndex = (rootIndex + semitones + 120) % 12;
  return getChromaticScale(preference)[noteIndex];
}

function resolveIntervalToken(token, notasMap) {
  if (!token) return "";

  if (token === "7M") {
    return notasMap[7] || transposeNote(notasMap[1], 11, "sharp");
  }

  if (token === "7" && notasMap[7]) {
    return notasMap[7];
  }

  if (/^\d+$/.test(token) && notasMap[Number(token)]) {
    return notasMap[Number(token)];
  }

  const match = token.match(/^([b#]?)(\d+)$/);
  if (!match) return token;

  const [, accidental, baseInterval] = match;
  const intervalNumber = Number(baseInterval);

  if (!accidental && notasMap[intervalNumber]) {
    return notasMap[intervalNumber];
  }

  const baseSemitones = semitonsByInterval[intervalNumber];
  if (baseSemitones === undefined) {
    return token;
  }

  const accidentalAdjustment = accidental === "b" ? -1 : accidental === "#" ? 1 : 0;
  const preference = accidental === "#" ? "sharp" : "flat";

  return transposeNote(notasMap[1], baseSemitones + accidentalAdjustment, preference);
}

function formatChordNotes(notasMap, left, right) {
  const leftNotes = left.map((token) => resolveIntervalToken(token, notasMap));
  const rightNotes = right.map((token) => resolveIntervalToken(token, notasMap));
  return `${leftNotes.join(" ")} | ${rightNotes.join(" ")}`;
}

export function exibeProgressaoNaTela(acordes = []) {
  const acordesValidos =
    Array.isArray(acordes) &&
    acordes.length === 4 &&
    acordes.every(
      (acorde) => acorde && typeof acorde.abertura === "string" && acorde.abertura.includes("|")
    );

  if (!acordesValidos) return [];

  const splitAbertura = (abertura) => abertura.split("|").map((parte) => parte.trim());
  const aberturasSplitted = acordes.map((acorde) => splitAbertura(acorde.abertura));
  const todosCamposHarmonicos = geraTodosCamposHarmonicos();
  const progressoes = [];
  const progressaoSelecionada = acordes.map((acorde) => acorde.grau).join(",");

  for (const tom in todosCamposHarmonicos) {
    if (todosCamposHarmonicos.hasOwnProperty(tom)) {
      const chord = todosCamposHarmonicos[tom];

      const aberturas = {
        acorde1: { left: aberturasSplitted[0][0], right: aberturasSplitted[0][1] },
        acorde2: { left: aberturasSplitted[1][0], right: aberturasSplitted[1][1] },
        acorde3: { left: aberturasSplitted[2][0], right: aberturasSplitted[2][1] },
        acorde4: { left: aberturasSplitted[3][0], right: aberturasSplitted[3][1] },
      };

      const acorde1 = obterAcorde(chord[acordes[0].grau], aberturas.acorde1.left, aberturas.acorde1.right);
      const acorde2 = obterAcorde(chord[acordes[1].grau], aberturas.acorde2.left, aberturas.acorde2.right);
      const acorde3 = obterAcorde(chord[acordes[2].grau], aberturas.acorde3.left, aberturas.acorde3.right);
      const acorde4 = obterAcorde(chord[acordes[3].grau], aberturas.acorde4.left, aberturas.acorde4.right);

      progressoes.push({
        tom,
        progressao: progressaoSelecionada,
        acordes: [
          {
            grau: acordes[0].grau,
            nome: nomeAcorde(acordes[0].grau, chord[acordes[0].grau]),
            notas: acorde1,
            intervalos: {
              left: parseIntervalos(aberturas.acorde1.left),
              right: parseIntervalos(aberturas.acorde1.right),
            },
          },
          {
            grau: acordes[1].grau,
            nome: nomeAcorde(acordes[1].grau, chord[acordes[1].grau]),
            notas: acorde2,
            intervalos: {
              left: parseIntervalos(aberturas.acorde2.left),
              right: parseIntervalos(aberturas.acorde2.right),
            },
          },
          {
            grau: acordes[2].grau,
            nome: nomeAcorde(acordes[2].grau, chord[acordes[2].grau]),
            notas: acorde3,
            intervalos: {
              left: parseIntervalos(aberturas.acorde3.left),
              right: parseIntervalos(aberturas.acorde3.right),
            },
          },
          {
            grau: acordes[3].grau,
            nome: nomeAcorde(acordes[3].grau, chord[acordes[3].grau]),
            notas: acorde4,
            intervalos: {
              left: parseIntervalos(aberturas.acorde4.left),
              right: parseIntervalos(aberturas.acorde4.right),
            },
          },
        ],
      });
    }
  }

  return progressoes;
}

export function exibeProgressaoPredefinidaNaTela(progressaoId) {
  const progressao = presetProgressions.find((item) => item.id === progressaoId);
  if (!progressao) return [];

  const todosCamposHarmonicos = geraTodosCamposHarmonicos();
  const progressoes = [];

  for (const tom in todosCamposHarmonicos) {
    if (todosCamposHarmonicos.hasOwnProperty(tom)) {
      const campo = todosCamposHarmonicos[tom];

      progressoes.push({
        tom,
        progressao: progressao.label,
        acordes: progressao.chords.map((acorde) => {
          const notasMap = campo[acorde.grau];
          return {
            grau: acorde.grau,
            rotulo: acorde.rotulo,
            nome:
              acorde.chordType === "6"
                ? `${notasMap[1]}6`
                : nomeAcorde(acorde.grau, notasMap),
            notas: formatChordNotes(notasMap, acorde.left, acorde.right),
            formula: `${acorde.left.join(" ")} | ${acorde.right.join(" ")}`,
            intervalos: { left: acorde.left, right: acorde.right },
          };
        }),
      });
    }
  }

  return progressoes;
}

export function converterNumerosParaNotas() {
  const harmonicosObject = geraTodosCamposHarmonicos();
  const notesInput = document.getElementById("notesInput").value;
  const noteNumbers = notesInput.split(",").map(Number);
  const notes = [];

  for (const prop in harmonicosObject) {
    if (harmonicosObject.hasOwnProperty(prop)) {
      const campoHarmonico = harmonicosObject[prop];

      noteNumbers.forEach((noteNumber) => {
        const note = campoHarmonico[noteNumber];
        if (note) {
          notes.push(note);
        }
      });
    }
  }

  const resultElement = document.getElementById("result");
  resultElement.textContent = `Notas correspondentes: ${notes.join(", ")}`;
}
